export const wiser = 'Wiser';

export const vehicleTypes = [
  { value: 'Car', label: 'Car' },
  { value: 'Truck', label: 'Truck' },
  { value: 'Cargo Van', label: 'Cargo Van' },
  { value: 'Porter', label: 'Porter' },
];
